
import { Layout } from "@/components/Layout";
import { AdminReviewDashboard } from "@/components/admin/AdminReviewDashboard";
import { AdminRoute } from "@/components/admin/AdminRoute";
import InfluencerInviteManager from "@/components/admin/InfluencerInviteManager";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const AdminDashboard = () => {
  return (
    <AdminRoute>
      <Layout>
        <div className="container mx-auto p-6">
          <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>
          
          <Tabs defaultValue="reviews" className="space-y-6">
            <TabsList>
              <TabsTrigger value="reviews">Content Reviews</TabsTrigger>
              <TabsTrigger value="influencers">Influencer Invites</TabsTrigger>
            </TabsList>
            
            <TabsContent value="reviews">
              <AdminReviewDashboard />
            </TabsContent>
            
            <TabsContent value="influencers">
              <InfluencerInviteManager />
            </TabsContent>
          </Tabs>
        </div>
      </Layout>
    </AdminRoute>
  );
};

export default AdminDashboard;